// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-1dJHo","lds-ring":"index-lds-ring-1phyy"};